module.exports = __webpack_public_path__ + "/build/web/images/logos/id-inspired-drapes/id-inspired-drapes@3x.67a53d65a35e9f9945b25654bc82b7d8.png";


//////////////////
// WEBPACK FOOTER
// ./images/logos/id-inspired-drapes/id-inspired-drapes@3x.png
// module id = 165
// module chunks = 13